import axios from 'axios';
import { toast } from 'react-toastify';
import { BASE_URL } from '../../Services/config';
import { inboxActions } from '../reducers/inboxReducer';
import { logout } from './authAction';

// Handle error messages
const getMessage = error => {
    let message = null;
    if (error && typeof error === 'object' && Object.keys(error).length) {
        if (error?.response && error?.response?.data) {
            if (error?.response?.data?.status && error?.response?.data?.status?.message) {
                if ((error?.response?.data?.status?.code === 400 && error?.response?.data?.status?.message === "User Not Found") || error?.response?.data?.status?.code === 401) {
                    logout()
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }
                message = error?.response?.data?.status?.message;
            }
        }
    }

    if (!message) {
        message = 'Unable to proceed at the moment!!';
    }

    return message;
};

export const inboxData = (category, page) => {
    return async dispatch => {
        const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
        const token = currentuser?.stsTokenManager
        dispatch(inboxActions.setLoading(false))
        try {
            const url = BASE_URL + `/app/inbox_list?page=${page}&limit=6&type=${category}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token?.accessToken}`,
                },
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        return response

                    default:
                        console.log(false);
                }
            }
        } catch (error) {
            const message = getMessage(error);
            toast.error(message);
        }
    }
}

export const acceptRequest = (props) => {
    return async dispatch => {
        const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
        const token = currentuser?.stsTokenManager
        dispatch(inboxActions.setLoading(false))
        try {
            const url = BASE_URL + `/app/request/acceptrequest`;
            const response = await axios.post(url, { sender: props }, {
                headers: {
                    Authorization: `Bearer ${token?.accessToken}`,
                },
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        return response

                    default:
                        console.log(false);
                }
            }
        } catch (error) {
            const message = getMessage(error);
            toast.error(message);
        }
    }
}

export const sendRequest = (props) => {
    return async dispatch => {
        const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
        const token = currentuser?.stsTokenManager
        dispatch(inboxActions.setLoading(false))
        try {
            const url = BASE_URL + `/app/request/sendrequest`;
            const response = await axios.post(url, { receiver: props }, {
                headers: {
                    Authorization: `Bearer ${token?.accessToken}`,
                },
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        return response

                    default:
                        console.log(false);
                }
            }
        } catch (error) {
            const message = getMessage(error);
            toast.error(message);
        }
    }
}

export const rejectRequest = (props) => {
    return async dispatch => {
        const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
        const token = currentuser?.stsTokenManager
        dispatch(inboxActions.setLoading(false))
        try {
            const url = BASE_URL + `/app/request/rejectrequest`;
            const response = await axios.post(url, { sender: props }, {
                headers: {
                    Authorization: `Bearer ${token?.accessToken}`,
                },
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        toast.success("Request Successfully Rejected")
                        return response

                    default:
                        console.log(false);
                }
            }
        } catch (error) {
            const message = getMessage(error);
            toast.error(message);
        }
    }
}

export const withdrawRequest = (props) => {
    return async dispatch => {
        const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
        const token = currentuser?.stsTokenManager
        dispatch(inboxActions.setLoading(false))
        try {
            const url = BASE_URL + `/app/request/withdrawrequest`;
            const response = await axios.post(url, { receiver: props }, {
                headers: {
                    Authorization: `Bearer ${token?.accessToken}`,
                },
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        toast.success("Request Withdraw Successfully")
                        return response

                    default:
                        console.log(false);
                }
            }
        } catch (error) {
            const message = getMessage(error);
            toast.error(message);
        }
    }
}

export const sendImage = (props) => {
    return async (dispatch, getState) => {
        const { accessToken } = getState().auth;
        dispatch(inboxActions.setLoading(true))

        // const { img, Imgdetail } = props

        var formData = new FormData();
        for (let i = 0; i < props.length; i++) {
            formData.append('image', props[i])
        }

        try {
            const url = BASE_URL + "/app/message/upload_document";
            const response = await axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${accessToken}`,
                }
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        dispatch(inboxActions.setLoading(false))
                        return response

                    default:
                        toast.error(response?.data?.message);
                        dispatch(inboxActions.setLoading(false))
                }
            }
        } catch (error) {
            console.log("error", error);
            if (error?.response?.data?.status?.message) {
                toast.error(error?.response?.data?.status?.message);
            } else {
                toast.error(error?.message);
            }
        }
        dispatch(inboxActions.setLoading(false))
    }
}


export const getProfile = (uid) => {
    return async dispatch => {
        const currentuser = JSON.parse(localStorage.getItem('matrimonialAuthCredentials'))
        const token = currentuser?.stsTokenManager
        dispatch(inboxActions.setLoading(false))
        try {
            const url = BASE_URL + `/app/show_other_profile?user=${uid}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token?.accessToken}`,
                },
            });
            if (response && response.status) {
                switch (response.status) {
                    case 200:
                        return response

                    default:
                        console.log(false);
                }
            }
        } catch (error) {
            const message = getMessage(error);
            toast.error(message);
        }
    }
}